<template>
  <v-layout justify-center>
    <v-flex>
      <v-card>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex align-center justify-center row fill-height xs12>
              <div class="text-xs-center ma-3" v-if="!isCommunityJoined">
                <v-btn v-if="user" round large color="teal" dark :loading="isCommunityJoined"
                       :disabled="isCommunityJoined" @click="joinCommunity">
                  Join the community<span slot="loader">Loading...</span>
                </v-btn>
              </div>
            </v-flex>

            <router-view
              :user="user"
              :communityId="communityId"
              :isCommunityJoined="isCommunityJoined"
              :isCommunityOwner="isCommunityOwner"
              :about="about"
              :categories="categories"
              @openCategoryDialog="categoryDialog = true"
            ></router-view>

            <v-dialog v-model="categoryDialog" fullscreen hide-overlay
                      transition="dialog-bottom-transition">
              <v-card>
                <v-toolbar dark color="teal">
                  <v-btn icon dark @click="categoryDialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>New Category Space</v-toolbar-title>
                </v-toolbar>
                <v-form>
                  <v-container>
                    <v-layout wrap>
                      <v-flex xs12 text-xs-center>
                        <v-text-field v-model="categoryId" label="Category ID"></v-text-field>
                        <v-text-field v-model="categoryName" label="Category Name"></v-text-field>
                        <v-layout row wrap>
                          <v-flex xs4 sm2>
                            <v-radio-group v-model="categoryColor" column>
                              <v-radio color="blue" value="blue">
                                <div slot="label" class="blue--text">blue</div>
                              </v-radio>
                              <v-radio color="indigo" value="indigo">
                                <div slot="label" class="indigo--text">indigo</div>
                              </v-radio>
                              <v-radio color="orange" value="orange">
                                <div slot="label" class="orange--text">orange</div>
                              </v-radio>
                              <v-radio color="deep-orange" value="deep-orange">
                                <div slot="label" class="deep-orange--text">deep-orange</div>
                              </v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex xs4 sm2>
                            <v-radio-group v-model="categoryColor" column>
                              <v-radio color="red" value="red">
                                <div slot="label" class="red--text">red</div>
                              </v-radio>
                              <v-radio color="pink" value="pink">
                                <div slot="label" class="pink--text">pink</div>
                              </v-radio>
                              <v-radio color="purple" value="purple">
                                <div slot="label" class="purple--text">purple</div>
                              </v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex xs4 sm2>
                            <v-radio-group v-model="categoryColor" column>
                              <v-radio color="green" value="green">
                                <div slot="label" class="green--text">green</div>
                              </v-radio>
                              <v-radio color="brown" value="brown">
                                <div slot="label" class="brown--text">brown</div>
                              </v-radio>
                              <v-radio color="blue-grey" value="blue-grey">
                                <div slot="label" class="blue-grey--text">blue-grey</div>
                              </v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                        <v-btn :loading="isCategoryCreating" :disabled="isCategoryCreating"
                               color="teal white--text" @click="createCategory()">
                          Go To Space
                          <span slot="loader">Loading...</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card>
            </v-dialog>

          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'HomeSpace',
  props: {
    user: Object,
    communityId: String,
    isCommunityJoined: Boolean,
    isCommunityOwner: Boolean,
    colors: Array,
    categories: Array,
    about: String,
  },
  data() {
    return {
      topicDialog: false,
      categoryDialog: false,
      isCategoryCreating: false,
      categoryId: '',
      categoryName: '',
      categoryColor: this.randomColor(),
    };
  },
  methods: {
    joinCommunity() {
      this.$emit('joinCommunity');
    },
    randomColor() {
      return this.colors[Math.floor(Math.random() * (this.colors.length))];
    },
    createCategory() {
      this.isCategoryCreating = true;
      const category = {
        name: this.categoryName,
        color: this.categoryColor,
        sort: this.categories.length + 1,
        userRef: firebase.firestore().doc(`users/${this.user.uid}`),
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      firebase.firestore().doc(`communities/${this.communityId}/categories/${this.categoryId}`).set(category)
        .then(() => {
          category.id = this.categoryId;
          this.$emit('createdCategory', category);
          this.$router.push(`/c/${this.communityId}/category/${this.categoryId}`);
          this.categoryDialog = false;
          this.isCategoryCreating = false;
          this.categoryId = '';
          this.categoryName = '';
          this.categoryColor = this.randomColor();
        })
        .catch(error => console.error(error));
    },
  },
};
</script>

<style scoped>
  .v-list__tile__avatar {
    min-width: 36px!important;
  }
  .v-avatar {
    width: 30px!important;
    height: 30px!important;
  }
</style>
